var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 32,
    viewBox: "0 0 111 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16428 0 0 7.16429 0 16C0 24.8357 7.16428 32 16 32C19.3872 32 22.5262 30.9472 25.1122 29.1517L27.9606 32L31.9982 27.9623L29.1499 25.114C30.9454 22.528 31.9982 19.3872 31.9982 16.0018C32 7.16429 24.8357 0 16 0ZM16 26.2803C10.3228 26.2803 5.71973 21.6772 5.71973 16C5.71973 10.3228 10.3228 5.71973 16 5.71973C21.6772 5.71973 26.2803 10.3228 26.2803 16C26.2803 21.6772 21.6772 26.2803 16 26.2803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5148 0.59021H70.7969V31.4115H76.5148V0.59021Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3807 0.59021H82.2344V31.4115H95.3807C103.892 31.4115 110.79 24.5113 110.79 16.0018C110.79 7.49217 103.892 0.59021 95.3807 0.59021ZM95.5349 25.7556H88.0144L87.947 6.26563L95.5367 6.24436C100.925 6.24436 105.073 10.6117 105.073 16C105.073 21.3883 100.925 25.7556 95.5367 25.7556H95.5349Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.362 17.7742C59.362 22.4907 55.521 26.2803 50.8045 26.2803C46.088 26.2803 42.2453 22.4907 42.2453 17.7742V0.59021H36.5273V17.7228C36.5273 25.6085 42.9188 32 50.8045 32C58.6902 32 65.0817 25.6085 65.0817 17.7228V0.59021H59.362V17.7742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuid);
export default __webpack_public_path__ + "static/media/QUID.0eb182ae4ba149407a6df3090b00a384.svg";
export { ForwardRef as ReactComponent };